import React from 'react';
import Component from './Component';

const Dataset = props => {
  return (
    <Component {...props} />
  );
};

export default Dataset;
